import { Locale } from "~constants/i18n";

/**
 * Generic helper function to get localized values with error tracking
 * Falls back to English if the requested locale is not available
 */
export function getLocalizedValue<T>(
  key: string | null,
  localeConfigs: Record<Locale, Record<string, T>>,
  locale: string = Locale.En,
  defaultValue: T
): T {
  if (!key) return defaultValue;

  // Try to get the requested locale config, fallback to English
  const localeConfig =
    localeConfigs[locale as Locale] || localeConfigs[Locale.En];

  if (!localeConfig) {
    const err = new Error(
      `getLocalizedValue: missing locale config for locale="${locale}", key="${key}"`
    );

    throw err;
  }

  return localeConfig[key] || defaultValue;
}
